module.exports = __webpack_public_path__ + "img/chevron-izquierdo-1.0b709fe0.svg";